import React from 'react';
function IngredientsSearch({ handleSearch, value }) {
    
    const onChange = (e) => {
        e.preventDefault();
        handleSearch(e.target.value)
    }

    return (
        <div className="ingredient-element search-container hoverable-element">
            <form onSubmit={e => e.preventDefault()}>
                <label>Search Ingredient:
                    <input
                        key="Ingredient_Search"
                        type="text"
                        id="Ingredient_Search"
                        name="Ingredient_Search"
                        placeholder="Search Ingredient Here..."
                        onChange={onChange}
                        value={value}
                    />
                </label>
            </form>
        </div>
    )
}

export default IngredientsSearch;